import React from 'react';

import { ViewLayout, AdvanceStack } from './components';
import { RibbonBar, RibbonDivider } from 'common/components';
import DetailSection from './components/sections/home-grid/DetailSection';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import UserActionsSection from './components/sections/user-maintenance-grid/UserActionsSection';
import MoveUserToMember from './components/sections/user-maintenance-grid/MoveUserToMember';
import UnlockUser from './components/sections/user-maintenance-grid/UnlockUser';
import MemberCommunicateSection from './components/sections/member-maintenance-grid/MemberCommunicateSection';
import UserEditRoleSecuritySection from './components/sections/user-maintenance-grid/UserEditRoleSecuritySection';
import FilterUsersSection from './components/sections/user-maintenance-grid/FilterUsersSection';

const UserMaintenanceGridView = () => {
  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection disabled />
      <ViewLayout disabled />

      <RibbonDivider />
      <MemberCommunicateSection isMemberGridInfoView={false} />
      <RibbonDivider />

      <UserEditRoleSecuritySection />
      <RibbonDivider />
      <UserActionsSection isUsersManagement={true} />
      <RibbonDivider />
      <MoveUserToMember />
      <RibbonDivider />
      {/* {isSuperAdmin && <FilterUserRole />} */}
      <FilterUsersSection />
      <UnlockUser />
      <RibbonDivider />
      <AdvanceStack isDisabled />
    </RibbonBar>
  );
};

export default UserMaintenanceGridView;
